import React from 'react';
import styled from 'styled-components';

import { isiOS, fitbitGreenText } from '../themes';

// Default false for not within SectionTitleContext
const SectionTitleContext = React.createContext(false);

export const SectionTitleChild = SectionTitleContext.Consumer;

export const SectionTitleBase = styled.h2`
  font: 14px 'Proxima Nova Semibold';
  margin: 0;
  margin-top: 20px;
  ${isiOS() ? `
    color: #767676;
    text-transform: uppercase;
    margin-bottom: 5px;
    padding-left: 15px;
  ` : `
    color: ${fitbitGreenText};
    margin-bottom: 32px;
    padding-left: 16px;
  `}
`;

export default ({ children }) => (
  <SectionTitleContext.Provider value={true}>
    <SectionTitleBase>{children}</SectionTitleBase>
  </SectionTitleContext.Provider>
);



// WEBPACK FOOTER //
// ./src/components/section-title.js